<template>
    <icon-base v-bind="$props">
        <circle cx="9" cy="7" r="3" />
        <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
        <path d="M16 3.5a3 3 0 0 1 0 7" />
        <path d="M21 21v-2a4 4 0 0 0 -3 -3.85" />
    </icon-base>
</template>

<script setup>
import IconBase, { iconProps } from './IconBase.vue'

defineProps(iconProps)
</script>
